import styled from 'styled-components';

type Props = {
  showButton: boolean;
};

export const VenueVisitsStyled = styled.div<Props>`
  width: 100%;
  .venueVisits {
    &__container {
      display: flex;
      justify-content: ${props => (props.showButton ? 'center' : 'start')};
      align-items: center;
      width: 100%;
    }

    &__content {
      display: flex;
      justify-content: center;
      background-color: ${props => props.theme.uiColors.contextSystemViewItemBackground};
      border-radius: 6px;
      padding: 16px;
      width: 100%;
    }
      
    &__itemsContainer {
      display: flex;
      flex-direction: column;
      gap: 24px;
      width: 100%;
    }
  }
`;
